/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ReapWorktreeResponse
 */
export interface ReapWorktreeResponse {
  /**
   *
   * @type {boolean}
   * @memberof ReapWorktreeResponse
   */
  reaped: boolean;
  /**
   *
   * @type {string}
   * @memberof ReapWorktreeResponse
   */
  reason?: string | null;
}

/**
 * Check if a given object implements the ReapWorktreeResponse interface.
 */
export function instanceOfReapWorktreeResponse(
  value: object,
): value is ReapWorktreeResponse {
  if (!("reaped" in value) || value["reaped"] === undefined) return false;
  return true;
}

export function ReapWorktreeResponseFromJSON(json: any): ReapWorktreeResponse {
  return ReapWorktreeResponseFromJSONTyped(json, false);
}

export function ReapWorktreeResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReapWorktreeResponse {
  if (json == null) {
    return json;
  }
  return {
    reaped: json["reaped"],
    reason: json["reason"] == null ? undefined : json["reason"],
  };
}

export function ReapWorktreeResponseToJSON(json: any): ReapWorktreeResponse {
  return ReapWorktreeResponseToJSONTyped(json, false);
}

export function ReapWorktreeResponseToJSONTyped(
  value?: ReapWorktreeResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    reaped: value["reaped"],
    reason: value["reason"],
  };
}
